<template>
    <ModalComponent
        :name="'Reactivar-' + name"
        :title="title"
        v-on:close="() => close()"
    >
        <div class="row">
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">Reactivar {{ name }}</h1>
            </div>

            <div class="col-12 text-center">
                <p>Para reactivar todas las {{ name }}, es necesario introducir el código de seguridad.</p>
            </div>

            <div class="col-12">
                <label for="codigoSeguridad">Código de seguridad</label>
                <input 
                    type="text" 
                    id="codigoSeguridad" 
                    class="form-control" 
                    v-model="codigoSeguridad" 
                />
            </div>

            <div class="col-12 text-rigth mt-3">
                <button type="button" class="btn btn-primary" @click.prevent="confirm()">Enviar</button>            
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            name: String,             
            title: String,           
            codigo_evento: String    
        },
        data() {
            return {
                codigoSeguridad: '',
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },

            confirm() {
                if (this.codigoSeguridad.trim() === '' || this.codigoSeguridad !== this.codigo_evento ) {
                    alert('Por favor, introduce el código de seguridad.');
                    return;
                } 
                if(this.codigoSeguridad === this.codigo_evento) {
                    this.$emit('confirm');
                }
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
